import { ReactNode } from 'react';
import { IconAttention } from '../icon/attention';
import styles from './style.module.scss';

type Props = {
  heading: string
}

const NoticeHeading = ({ heading }: Props) => {
  return (
    <div className={styles.noticeHeading}>
      <IconAttention />
      <p className={styles.noticeHeadingValue}>{heading}</p>
    </div>
  )
}

export { NoticeHeading }
